import _ from 'lodash';
import moment from 'moment';

import DataTable from '../../../core/charts/Datatable';
import translate from '../../../core/tools/translate';

import * as topojson from 'topojson-client';

const getValueIcon = (val1, val2) => {
    return val1 < val2
        ? '<i class="fa fa-caret-up" style="color: #2ecc71"></i>'
        : '<i class="fa fa-caret-down" style="color: #e74c3c"></i>';
};

const reducers = {
    store (res) {
        const doc = {};
        doc.address = res.endereco;
        doc.indicators = res.indicadores;
        doc.information = res.informacoes;
        doc.location = res.localizacao;

        if (_.size(res.tipoServicoLoja)) {
            doc.services = {
                grid: {
                    dataSource: _(res.tipoServicoLoja)
                        .orderBy(t => parseInt(t.ano))
                        .reverse()
                        .groupBy(l => l.ano)
                        .map((val, key) => ({
                            Ano: key,
                            [val[0].Tipo_Servico]: val[0].Quantidade,
                            [val[1].Tipo_Servico]: val[1].Quantidade,
                            [val[2].Tipo_Servico]: val[2].Quantidade
                        }))
                        .value(),
                    autoheight: true,
                    scrollable: false,
                    columns: [
                        {
                            title: 'Ano',
                            field: 'Ano'
                        },
                        {
                            title: 'Cpus',
                            field: 'CPUS',
                            format: '{0:n0}'
                        },
                        {
                            title: 'Garantia',
                            field: 'GARANTIA',
                            format: '{0:n0}'
                        },
                        {
                            title: 'Interno',
                            field: 'INTERNO',
                            format: '{0:n0}'
                        }
                    ]
                }
            };
        }

        return doc;
    },

    storeUnapproved (res) {
        const doc = {};
        doc.address = res.endereco;
        doc.information = res.informacoes;
        doc.location = res.localizacao;

        return doc;
    },

    storePlanned(res) {
        const doc = {};
        doc.address = res.endereco;
        doc.information = res.informacoes;
        doc.location = res.localizacao;

        return doc;
    },

    protectArea(data) {
        return topojson.feature(data, data.objects.output);
    },
};

reducers.directSales = {
    period (res) {
        let start = moment().startOf('year').toDate();
        let end = moment().subtract(1, 'month').toDate();

        if (res && res.finalDate) {
            end = moment(res.finalDate).toDate();
        }

        if (res && res.initialDate) {
           start = moment(res.initialDate).toDate();
        }

        return ({ start, end });
    }
};

reducers.retention = {
    period (res) {
        let start = moment().startOf('year').toDate();
        let end = moment().subtract(2, 'month').toDate();

        //Requested by Maria to restrict in fixed period
        start = new Date(2018, 1, 1);
        end = new Date();

        // if (res.initialDate) {
        //     start = moment(res.initialDate).toDate();
        // }

        // if (res && res.finalDate) {
        //     end = moment(res.finalDate).toDate();
        // }

        return ({ start, end });
    }
};

reducers.sales = {};

reducers.sales.bySegment = (res) => {
    return new DataTable(_(res).orderBy(r => r.ano).reverse().value(), {
        row: ['segmento'],
        column: ['ano'],
        value: ['venda']
    });
};

reducers.sales.history = (res) => {
    if (!res) return;

    const doc = {
        variation: res.variacao,
        lastYear: res.lastYear,
        previousYear: res.previousYear
    };

    const storeSales = (() => {
        if (!_.size(res.emplacamentosConcessionarias)) {
            return [];
        }

        const data = _.map(_.range(2), () => ({ [translate('Common.Year')]: 0, [translate('Common.Average')]: 0, [translate('Common.Registrations')]: [] }));

        _.forEach(res.emplacamentosConcessionarias, sales => {
            const index = sales.ano === _.maxBy(res.emplacamentosConcessionarias, e => e.ano).ano ? 1 : 0;
            data[index] = {
                [translate('Common.Average')]: sales.media,
                [translate('Common.Year')]: sales.ano,
                [translate('Common.Registrations')]: _.map(sales.emplacamentosMes, (sale) => {
                    sale.ano = sales.ano;
                    return sale;
                })
            };
        });

        return data;
    })();

    if (_.size(storeSales)) {
        doc.sales = _.map(storeSales, (val) =>
            ({
                year: val[translate('Common.Year')],
                avg: val[translate('Common.Average')],
                months: _.map(val[translate('Common.Registrations')], (v) =>
                    ({
                        month: v.mes,
                        sale: v.vendas
                    })
                )
            })
        );

        const maxMonth = Math.max(...storeSales[0].Emplacamentos.map(x => x.mes), ...storeSales[1].Emplacamentos.map(x => x.mes));
        const months = Array.from({ length: maxMonth }, (value, index) => index + 1);

        const dataChart = storeSales
            .map(x => {
                x.Emplacamentos = [
                    ...x.Emplacamentos,
                    ...months.filter(y => !x.Emplacamentos.some(e => e.mes === y)).map(y => ({ mes: y, vendas: 0, ano: x.Ano }))
                ];
                x.Emplacamentos = x.Emplacamentos.sort((a, b) => a.mes - b.mes);
                return x;
            });

        doc.chart = new DataTable(_.reduce(dataChart, (acc, val) => {
            acc = _(val[translate('Common.Registrations')]).map(v => ({
                [translate('Common.Month')]: v.mes,
                [translate('Common.Sales')]: v.vendas,
                [translate('Common.Year')]: v.ano
            })).concat(acc).sortBy('Ano').value();
            return acc;
        }, []), {
            row: [translate('Common.Year')],
            column: [translate('Common.Month')],
            value: [translate('Common.Sales')],
            header (value) {
                return moment(value, 'MM').format('MMM');
            }
        });
    }

    if (_.size(res.emplacamentoAcumulado)) {
        doc.grid = {
            dataSource: _(res.emplacamentoAcumulado).map((e) =>
                ({
                    Ano: e.ano,
                    Media: e.media,
                    Total: e.total,
                    Periodo: _.map(e.periodo, (p) => moment(p, 'MM').format('MMM')).join(' - ')
                })
            ).orderBy((e) => e.ano).reverse().value(),
            columns: [
                {
                    title: translate('Common.Year'),
                    field: 'Ano'
                },
                {
                    title: translate('Common.Period'),
                    field: 'Periodo'
                },
                {
                    title: translate('Common.Average'),
                    field: 'Media',
                    format: '{0:n2}'
                },
                {
                    field: 'Total',
                    format: '{0:n0}'
                }
            ]
        };
    }

    return doc;
};

reducers.featuresProperties = (res) => {
    if (!res || !res.objects || !res.objects.output || !res.objects.output.geometries) {
        return [];
    }

    return _.map(res.objects.output.geometries, f => f.properties);
};

export default reducers;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/store/reducers.js